import { FileLogger, BaseRestResource, RestTypeConnection, BaseModel, TransactionError } from "ecloud-base-connector";
import { envSelector } from "@environment";
import { Request } from "./_request";

export abstract class BaseResource<T extends BaseModel> extends BaseRestResource {
	abstract modelName: string;

	constructor({ logger = null }: { logger?: FileLogger | null } = {}, connection?: RestTypeConnection) {
		super(connection ?? envSelector.selectedEnv.getConnection(), { logger });
	}

	getLoggerExtension() {
		return `Magento${this.constructor.name}`;
	}

	public getRequest() {
		return new Request(this.modelName);
	}

	abstract parse(data: any): T;

	public async filter(request: Request): Promise<T[]> {
		try {
			const uri = `/demo/api/${this.modelName}`;
			const queryParams = request.getQueryData();
			const modelList = await this.get(uri, { params: queryParams });
			return modelList.map((modelData: any) => this.parse(modelData));
		} catch (error) {
			const errorMessage = `Error getting data for ${this.modelName} list`;
			this.logger.error(errorMessage, error);
			return Promise.reject(new TransactionError(error, errorMessage));
		}
	}

	public async getOne(modelID: number): Promise<T> {
		try {
			const uri = `/demo/api/${this.modelName}/${modelID}`;
			return await this.get(uri);
		} catch (error) {
			const errorMessage = `Error getting data for ${this.modelName} ${modelID}`;
			this.logger.error(errorMessage, error);
			return Promise.reject(new TransactionError(error, errorMessage, { modelID }));
		}
	}
}